import '.a0{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.hg{height:28px;}.ssr-plugin'
import '.hh{max-width:700px;}.ssr-plugin'
import '.df{display:inline-flex;}.ssr-plugin'
import '.a9{pointer-events:none;}.ssr-plugin'
import '.be{position:fixed;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.hi{transition:opacity 0.15s cubic-bezier(0.45, 1.45, 0.8, 1), visibility 0.15s;}.ssr-plugin'
import '.fx{white-space:nowrap;}.ssr-plugin'
import '.fc{z-index:4;}.ssr-plugin'
import React, { useState, useEffect, useRef } from 'react'
import { styled, Style } from 'inlines'
import { Key, KeyHint } from '../KeyHint/index.js'
import { measureTextWidth, Text } from '../Text/index.js'
import { colors } from '../../tokens/colors.js'
import { shadows } from '../../utils/shadows.js'
import { radius } from '../../utils/radius.js'

type TooltipProps = {
  description?: string
  keyHint?: Key
  children: React.ReactNode
  tableTooltip?: boolean
  style?: Style
}

export const Tooltip = ({
  description,
  keyHint,
  children,
  tableTooltip,
  style,
}: TooltipProps) => {
  const viewportWidth = window.innerWidth
  const viewportHeight = window.innerHeight
  const [hover, setHover] = useState(false)
  const [tooltipPosition, setTooltipPosition] = useState({
    translateX: -viewportWidth,
    translateY: -viewportHeight,
  })
  const tooltipRef = useRef(null)

  if (!description) {
    return children
  }

  return (
    <div className="a0">
      <div className="a"
        onMouseEnter={(e) => {
          setHover(true)

          let translateX = 0
          let translateY = 0
          const rect = e.currentTarget.getBoundingClientRect()
          const offset = 17
          const tooltipContainerWidth = Math.round(
            tooltipRef.current.getBoundingClientRect().width,
          )
          const containerWidth = tooltipContainerWidth
          const targetWidth = rect.width
          const targetHeight = rect.height + offset
          const targetDimensionY = rect.bottom + targetHeight
          const targetDimensionX = rect.right + offset

          if (targetDimensionX >= viewportWidth) {
            translateX = -(containerWidth - rect.width)
          } else {
            if (containerWidth >= targetWidth - offset) {
              translateX = -(containerWidth / 2 - targetWidth / 2)
            } else {
              translateX = (targetWidth - containerWidth) / 2
            }
          }

          if (targetDimensionY >= viewportHeight) {
            translateY = -(targetHeight + offset)
          }

          setTooltipPosition({
            translateX: tableTooltip ? translateX : rect.left + translateX,
            translateY: tableTooltip ? translateY : rect.bottom + translateY,
          })
        }}
        onMouseLeave={() => setHover(false)}
      >
        {children}
      </div>
      <styled.div className="hg hh df a9 be c b hi fx fc"
        ref={tooltipRef}
        style={{
          background: colors.neutralInverted100,
          border: `1px solid  ${colors.neutral20Adjusted}`,
          visibility: hover ? 'visible' : 'hidden',
          opacity: hover ? 1 : 0,
          left: tableTooltip ? undefined : tooltipPosition?.translateX || 0,
          top: tableTooltip
            ? undefined
            : tooltipPosition?.translateY
              ? tooltipPosition.translateY + 4
              : 0,
          boxShadow: shadows.popoverSmall,
          borderRadius: radius[8],
          padding:
            keyHint && description
              ? '0 6px 0 8px'
              : keyHint
                ? '0 6px'
                : '0 8px',
          transform: !tableTooltip
            ? undefined
            : tooltipPosition?.translateX !== undefined &&
                tooltipPosition?.translateY !== undefined
              ? `translateX(${tooltipPosition?.translateX}px) translateY(${tooltipPosition?.translateY}px)`
              : undefined,
          ...style,
        }}
      >
        {description && (
          <Text variant="subtext-medium" color="neutral100" singleLine>
            {description}
          </Text>
        )}
        {keyHint && <KeyHint hint={keyHint} />}
      </styled.div>
    </div>
  )
}
